package com.elan.edubridge.ui.member

import com.elan.edubridge.ui.shell.STUDENT_APP_NAME
import com.elan.edubridge.ui.shell.StoreLinks
import com.elan.edubridge.ui.shell.escapeHtml
import com.elan.edubridge.ui.shell.icon

/**
 * "QR 스캔과 푸시 알림은 앱에서" 상시 배너(가이드 §3.7). [MemberShell]이 모든 회원 뷰 콘텐츠
 * 최상단에 항상 끼워 넣는다.
 *
 * 회원 뷰는 학생·보호자의 자리이므로 링크는 학생·보호자 앱([STUDENT_APP_NAME]) 하나뿐이다.
 * 스토어 배지 묶음은 비로그인 화면(랜딩·QR 착지) 전용이고, 여기서는 문구와 링크 한 줄만 둔다.
 */
object AppDownloadBanner {
    fun render(): String {
        val link = StoreLinks.studentPlay?.let {
            """<a href="${it.escapeHtml()}" target="_blank" rel="noopener">Google Play에서 앱 받기</a>"""
        }.orEmpty()
        return """
            <aside class="eb-app-banner">
                ${icon("icon-qr", "md")}
                <span>QR 스캔과 푸시 알림은 EduBridge 앱에서 이용할 수 있어요.</span>
                $link
            </aside>
        """.trimIndent()
    }
}
